/**
 * Autoetiquetado determinístico de intención (R3.5).
 *
 * Clasificador liviano por palabras clave para señalizar RECLAMOS de producto
 * en mensajes y comentarios, sin tocar el motor de moderación (CM AI) ni el
 * ingest — corre en el cliente sobre el texto ya recibido. Es una AYUDA visual
 * para el operador, no una decisión de moderación.
 *
 * El mismo criterio se replica server-side en el Centro de Monitoreo para los
 * agregados por tema (mantener ambas listas en sync si se amplían).
 */

// Patrones de reclamo/queja de producto en español rioplatense/neutro.
const RECLAMO_PATTERNS: RegExp[] = [
  /\breclam(o|ar|ando|é|e)\b/i,
  /\bqueja\b/i,
  /\bdefectuos[oa]s?\b/i,
  /\bfall(a|ó|ado|ada)\b/i,
  /\bno\s+(funciona|funcionó|sirve|sirvió|anda|andaba)\b/i,
  /\bvino\s+(mal|roto|rota|abiert[oa]|fallad[oa]|vencid[oa])\b/i,
  /\brot[oa]s?\b/i,
  /\bvencid[oa]s?\b/i,
  /\bmala\s+calidad\b/i,
  /\bp[ée]sim[oa]\b/i,
  /\bhorrible\b/i,
  /\bmal[íi]sim[oa]\b/i,
  /\bdevoluci[óo]n\b/i,
  /\breembols(o|ar)\b/i,
  /\bestafa\b/i,
  /\bqueremos?\s+(un\s+)?cambio\b/i,
  /\bproblema\s+con\s+el\s+producto\b/i,
];

/** True si el texto parece un reclamo/queja de producto. */
export function isReclamo(text: string | null | undefined): boolean {
  if (!text) return false;
  return RECLAMO_PATTERNS.some((re) => re.test(text));
}
